import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";

import { Button, Input } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress";
import NumberFormat from "react-number-format";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { RootState } from "../../models/RootState";
import { BsData } from "../../models/BsData";
import { BUTTON_VARIABLES } from "../../constants/ButtonVariables";
import closeIcon from "../../assets/images/close.png";
import {
  removeExchangeBet,
  setExchangeBetStake,
  clearExchcngeBets,
  exchangeBetOddsChange,
  fetchOpenBets,
  fetchBalance,
  setBetSlipOddsChangeMsg,
  acceptOddsChange,
} from "../../store";
import API from "../../services";
import { USER_API } from "../../services";
import "./BetSlip.scss";
import { MarketNamesMap } from "../../constants/common-utlits";

type StoreProps = {
  bets: BsData[];
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: "ADD" | "SET"
  ) => void;
  setBetSlipOddsChangeMsg: (value: boolean) => void;
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  clearExchangeBets: () => void;
  fetchOpenBets: (eventId, sportId) => void;
  fetchBalance: Function;
  acceptOddsChange: () => void;
  page: string;
  enqueueSnackbar?: any;
  oddsChanged: boolean;
  betSuspended: boolean;
  betSlipMessage: string;
  userBalance: number;
  currency: string;
};

const Betslip: React.FC<StoreProps> = (props) => {
  const {
    bets,
    setExchangeBetStake,
    removeExchangeBet,
    clearExchangeBets,
    exchangeBetOddsChange,
    fetchOpenBets,
    acceptOddsChange,
    fetchBalance,
    oddsChanged,
    betSuspended,
    betSlipMessage,
    page,
    userBalance,
    currency,
  } = props;

  const [loading, setLoading] = useState(false);
  const [stackFocus, setStackFocus] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  let providerId = sessionStorage.getItem("psProviderId");
  let operatorId = sessionStorage.getItem("psOperatorId");

  useEffect(() => {
    setStackFocus(true);
  }, [bets]);

  // useEffect(() => {
  //   return enqueueSnackbar("Bet successfully tested", {
  //     variant: "error",
  //   });
  // }, []);

  const onChangeOddHandler = (index: any, data: BsData, control: number) => {
    if (data.oddValue === 1 || page === "sportradar") {
      return false;
    }

    let value;
    if (control === 1) {
      value = (data.oddValue + 0.01).toFixed(2);
    } else {
      value = (data.oddValue - 0.01).toFixed(2);
    }
    exchangeBetOddsChange(index, parseFloat(value.toString()));
  };

  const placeBet = async (data: BsData) => {
    console.log("dataa", data);
    // if (!userBalance || userBalance < data.stakeAmount) {
    //   setLoading(false);
    //   return enqueueSnackbar("Bet not placed, Insufficient funds", {
    //     variant: "error",
    //   });
    // }

    if (data?.stakeAmount < 0) {
      return enqueueSnackbar("Invalid stake amount.", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
    if (
      (data?.minLimit !== 0 && data?.minLimit > data?.stakeAmount) ||
      (data?.maxLimit !== 0 && data?.maxLimit < data?.stakeAmount)
    ) {
      return enqueueSnackbar(
        `Total Stake should not be less than ${data?.minLimit} and
      should not exceed: ${data?.maxLimit}. `,
        {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
    }
    try {
      setLoading(true);
      const payload = {
        token: sessionStorage.getItem("psAuthToken"),
        partnerId: sessionStorage.getItem("psPartnerId"),
        operatorId: operatorId,
        providerId: sessionStorage.getItem("psProviderId"),
        sportId: data.sportId,
        competitionId: data.competitionId,
        eventId: data.eventId,
        betType: data.betType,
        oddValue: data.oddValue,
        stakeAmount: data?.stakeAmount,
        // stakeAmount:
        //   page === "sportradar"
        //     ? Number(data?.stakeAmount * 0.1)
        //     : data?.stakeAmount,
        marketType: data.marketType
          ? data.marketType
          : MarketNamesMap(data.marketName.replace(/\s/g, "")),
        marketName: data.marketName,
        marketId: data.marketId,
        runnerId: data.runnerId,
        runnerName: data.runnerName,
        sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
        origin: sessionStorage.getItem("lobbyType")
        // sessionOutcome: data.sessionOutcome,
      };

      const res: any = await API.post("/sportsbet", payload);
      if (res.data.status === "") {
        setLoading(false);

        return enqueueSnackbar(res.data?.errorDescription, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      } else if (res.data.status === "RS_OK") {
        if (res.data.betId && !res.data.errorDescription) {
          return getBetStatus(data, res.data.betId);
        } else {
          setLoading(false);
          return enqueueSnackbar(res.data?.errorDescription, {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        }
      }
    } catch (e) {
      setLoading(false);
      return enqueueSnackbar("Something went wrong, try again", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

  const getBetStatus = async (data: BsData, betId: string) => {
    setLoading(true);
    const payload = {
      betId: betId,
      eventId: data.eventId,
      partnerId: sessionStorage.getItem("psPartnerId"),
      operatorId: operatorId,
      providerId: sessionStorage.getItem("psProviderId"),
      sportId: data.sportId,
      token: sessionStorage.getItem("user_api_token"),

        competitionId: data.competitionId,
        betType: data.betType,
        oddValue: data.oddValue,
        stakeAmount: data?.stakeAmount,
        // stakeAmount:
        //   page === "sportradar"
        //     ? Number(data?.stakeAmount * 0.1)
        //     : data?.stakeAmount,
        marketType: data.marketType
          ? data.marketType
          : MarketNamesMap(data.marketName.replace(/\s/g, "")),
        marketName: data.marketName,
        marketId: data.marketId,
        runnerId: data.runnerId,
        runnerName: data.runnerName,
        sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
        origin: sessionStorage.getItem("lobbyType")
        // sessionOutcome: data.sessionOutcome,
    };

    while (1) {
      const res: any = await USER_API.post("/userbet-status", payload);
      if (["BETTING_IN_PROGRESS", "PENDING"].includes(res.data.betStatus)) {
        await new Promise((f) => setTimeout(f, 500));
        continue;
      } else if (
        res.data.status === "RS_OK" &&
        ["CANCELLED", "EXPIRED", "FAILED"].includes(res.data.betStatus)
      ) {
        setLoading(false);
        return enqueueSnackbar(
          res.data.betErrorMsg
            ? res.data.betErrorMsg
            : "Bet is not placed, try again",
          {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          }
        );
      } else if (res.data?.betStatus === "OPEN") {
        setLoading(false);
        clearExchangeBets();
        featchOpenBets(data.eventId, data.sportId);
        return enqueueSnackbar(
          res.data.errorDescription
            ? res.data.errorDescription
            : "Bet placed successfully.",
          {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          }
        );
      }
    }
  };

  const featchOpenBets = (eventId: string, sportId: string) => {
    fetchOpenBets(eventId, sportId);
    fetchBalance();
  };

  const oddsChange = (index, val) => {
    if (val) exchangeBetOddsChange(index, parseFloat(val.toString()));
  };

  return (
    <div className="betslip-ctn">
      {loading ? (
        <div className="betslip-progress">
          <div className="centered">
            <CircularProgress className="icon" />
          </div>
        </div>
      ) : null}

      <div className="body-ctn">
        {bets && bets.length > 0
          ? bets.map((data, index) => {
              return (
                <React.Fragment key={`${data?.eventId}-${data?.marketId}-${data?.runnerId}-${index}`}>
                  <div className="bet-body">
                    <div className="header-row">
                      <div className="event">{data?.eventName}</div>
                      <img
                        className="close-icon"
                        src={closeIcon}
                        alt="close"
                        onClick={() => removeExchangeBet(index)}
                      />
                    </div>
                    <div
                      className={
                        page === "sportradar"
                          ? "bet-card"
                          : data?.betType === "BACK"
                          ? "back-bg bet-card"
                          : "lay-bg bet-card"
                      }
                    >
                      <div className="market">
                        {data?.marketName} @{" "}
                        {data.marketType === "FANCY"
                          ? data?.oddValue
                          : data?.runnerName}{" "}
                      </div>

                      <div className="input-row">
                        <div className="input-row-ctn odds-ctn">
                          <div className="row-header">
                            {data.marketType === "FANCY" ? "Runs" : "Odds"}
                          </div>

                          <div className="row-input-odds">
                            {data.marketType !== "FANCY" ? (
                              <Button
                                className="odds-btns"
                                startIcon={<RemoveIcon />}
                                onClick={() =>
                                  onChangeOddHandler(index, data, 0)
                                }
                                disabled={data.marketType !== "MATCH_ODDS"}
                              ></Button>
                            ) : null}

                            <NumberFormat
                              value={
                                data.marketType === "FANCY"
                                  ? data?.sessionOutcome.toFixed(2)
                                  : data?.oddValue?.toFixed(2)
                              }
                              decimalScale={2}
                              thousandSeparator={true}
                              thousandsGroupStyle="lakh"
                              className="row-input"
                              allowNegative={false}
                              disabled={
                                providerId !== "BetFair" ||
                                data.marketType !== "MATCH_ODDS" ||
                                page === "sportradar"
                              }
                              onValueChange={(val) => {
                                oddsChange(index, val.floatValue);
                              }}
                              style={{
                                height: "30px",
                                border: 0,
                                padding: "2px",
                              }}
                            ></NumberFormat>

                            {data.marketType !== "FANCY" ? (
                              <Button
                                className="odds-btns mr-1"
                                startIcon={<AddIcon />}
                                onClick={() =>
                                  onChangeOddHandler(index, data, 1)
                                }
                                disabled={data.marketType !== "MATCH_ODDS"}
                              ></Button>
                            ) : null}
                          </div>
                        </div>

                        <div className="input-row-ctn">
                          <div className="row-header">
                            {data.betType === "BACK" ? "Stake" : "Profit"}
                          </div>
                          <NumberFormat
                            value={data?.stakeAmount ? data?.stakeAmount : ""}
                            thousandSeparator={true}
                            thousandsGroupStyle="lakh"
                            className="row-input"
                            decimalScale={operatorId === "MPC1" ? 0 : 2}
                            allowNegative={false}
                            disabled={loading}
                            onValueChange={(val) => {
                              setExchangeBetStake(index, val.floatValue, "SET");
                            }}
                            style={{
                              height: "30px",
                              border: 0,
                              padding: "2px",
                            }}
                            autoFocus={false}
                          ></NumberFormat>
                        </div>
                      </div>
                      <div className="clear-row">
                        <span
                          className={
                            loading ? "disabled text b-text" : "text b-text"
                          }
                          onClick={() => {
                            setExchangeBetStake(index, 0, "SET");
                          }}
                        >
                          Clear
                        </span>
                      </div>

                      <div className="quick-bet">
                        {BUTTON_VARIABLES.map((bV, idx) => (
                          <Button
                            key={"qb-btn" + idx}
                            className="qb-btn"
                            disabled={loading}
                            onClick={() =>
                              setExchangeBetStake(index, bV.amount, "ADD")
                            }
                          >
                            +{bV.label}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {oddsChanged || betSuspended ? (
                    <div className="betslip-notification-ctn">
                      <div className="betslip-notification-msg">
                        {betSlipMessage}
                      </div>
                      {oddsChanged && !betSuspended ? (
                        <Button onClick={() => acceptOddsChange()}>
                          Accept
                        </Button>
                      ) : null}
                    </div>
                  ) : null}

                  <div className="bet-footer">
                    <div className="stake-section">
                      <div className="stake-label">
                        {data.betType === "LAY" ? "Liability" : "Profit"}
                      </div>

                      <div className="stake-value">
                        {/* Rs. {bets.reduce((a, v) => a + v.stakeAmount, 0)} */}
                        {currency ?? currency}.{" "}
                        {/* {bets && bets.length > 0 && bets[0]?.stakeAmount
                          ? bets[0]?.stakeAmount
                          : 0} */}
                        <span
                          className={
                            data.betType === "BACK" ? "profit" : "loss"
                          }
                        >
                          {data.marketType === "MATCH_ODDS"
                            ? data.betType === "BACK"
                              ? (
                                  data.stakeAmount *
                                  (data.oddValue - 1)
                                ).toFixed(2)
                              : (
                                  (data.oddValue - 1) *
                                  data.stakeAmount
                                ).toFixed(2)
                            : data.marketType === "BOOKMAKER"
                            ? data.betType === "BACK"
                              ? (
                                  data.stakeAmount *
                                  ((data.oddValue + 100) / 100 - 1)
                                ).toFixed(2)
                              : (
                                  ((data.oddValue + 100) / 100 - 1) *
                                  data.stakeAmount
                                ).toFixed(2)
                            : data.betType === "BACK"
                            ? (
                                data.stakeAmount *
                                ((data.oddValue + 100) / 100 - 1)
                              ).toFixed(2)
                            : (
                                ((data.oddValue + 100) / 100 - 1) *
                                data.stakeAmount
                              ).toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="place-section">
                      {!loading ? (
                        <button
                          className="place-btn"
                          disabled={
                            loading ||
                            oddsChanged ||
                            betSuspended ||
                            isNaN(data?.stakeAmount) ||
                            data?.stakeAmount === 0
                          }
                          onClick={() => {
                            placeBet(data);
                            // setLoading(true);
                          }}
                        >
                          {" "}
                          <div className="label">Place Bet</div>
                        </button>
                      ) : (
                        <LoadingButton
                          loading
                          variant="outlined"
                          loadingPosition="center"
                          className="place-btn"
                        ></LoadingButton>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              );
            })
          : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userBalance: state.sportsBook.balance,
    bets: state.betslip.bets,
    oddsChanged: state.betslip.oddsChanged,
    betSuspended: state.betslip.betSuspended,
    betSlipMessage: state.betslip.message,
    currency: state.sportsBook.currency,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: "ADD" | "SET") =>
      dispatch(setExchangeBetStake(index, amount, type)),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange(index, odds)),
    // placeBet: (data) => dispatch(placeBet(data)),

    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    fetchBalance: () => dispatch(fetchBalance()),
    setBetSlipOddsChangeMsg: (flag: boolean) =>
      dispatch(setBetSlipOddsChangeMsg(flag)),
    acceptOddsChange: () => dispatch(acceptOddsChange()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Betslip);
